import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CommonLayoutComponent } from "./pages/common-layout/common-layout/common-layout.component";
import { ErrorpageComponent } from "./errorpage/errorpage.component";
import { PageNotFoundComponent } from "./pages/login/page-not-found/page-not-found.component";
import { SwitchAcComponent } from "./switch-ac/switch-ac.component";
import { SiteUnderMaintenanceComponent } from "./site-under-maintenance/site-under-maintenance.component";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => {
        const mod = m.LoginModule;
        if (!mod) {
          throw new Error(
            "LoginModule not found in chunk. Exports: " + Object.keys(m).join(", ")
          );
        }
        return mod;
      }),
    data: { title: "Login" },
  },
  {
    path: "switch-account",
    component: SwitchAcComponent,
  },
  {
    // User Profile / Security without a site, reached from the Switch Account user menu.
    path: "account",
    loadChildren: () =>
      import("./account-shell/account-shell.module").then((m) => m.AccountShellModule),
  },
  {
    path: "something-wrong",
    component: ErrorpageComponent,
  },
  {
    path: "site-under-maintenance",
    component: SiteUnderMaintenanceComponent,
  },
  // { path: "common-layout", loadChildren: () => import('../app/pages/common-layout/common-layout.module').then(m => m.CommonLayoutModule), data: { title: "Common Layout" } },
  {
    path: "paybev/:siteId",
    component: CommonLayoutComponent,
    data: { title: "" },
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/common-layout/common-layout.module").then((m) => {
            const mod = m.CommonLayoutModule;
            if (!mod) {
              throw new Error(
                "CommonLayoutModule not found in chunk. Exports: " +
                  Object.keys(m).join(", ")
              );
            }
            return mod;
          }),
      },
    ],
    // resolve: { data: ExampleResolverService },
  },
  { path: "page-not-found", component: PageNotFoundComponent },
  {
    path: "**",
    redirectTo: "/page-not-found",
    pathMatch: "full",
    data: { title: "Page Not Found" },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
